import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1848907e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  style: {"color":"#08c"}
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("取消")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_tree_select = _resolveComponent("a-tree-select")!
  const _component_EditorComponent = _resolveComponent("EditorComponent")!
  const _component_a_form_item_rest = _resolveComponent("a-form-item-rest")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, { title: "设置文章" }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form, {
        ref: "formRef",
        model: _ctx.formState,
        rules: _ctx.rules,
        "label-col": _ctx.labelCol,
        "wrapper-col": _ctx.wrapperCol
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, {
            ref: "title",
            label: "文章标题",
            name: "title"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.formState.title,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.title) = $event)),
                placeholder: "请输入"
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 512),
          _createVNode(_component_a_form_item, {
            ref: "documentation_cate_id",
            label: "所属分类",
            name: "documentation_cate_id"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_tree_select, {
                value: _ctx.formState.documentation_cate_id,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.documentation_cate_id) = $event)),
                placeholder: "请选择上级菜单",
                "tree-line": true,
                "tree-default-expand-all": "",
                "allow-clear": "",
                "tree-data": _ctx.category,
                fieldNames: {children:'children', label:'title', key:'id', value: 'id' }
              }, {
                title: _withCtx(({ value: val, title }) => [
                  (val === _ctx.formState.documentation_cate_id)
                    ? (_openBlock(), _createElementBlock("b", _hoisted_1, _toDisplayString(title), 1))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(title), 1)
                      ], 64))
                ]),
                _: 1
              }, 8, ["value", "tree-data"])
            ]),
            _: 1
          }, 512),
          _createVNode(_component_a_form_item, {
            ref: "content",
            label: "内容",
            name: "content",
            placeholder: "请输入"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.formState.content,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formState.content) = $event)),
                class: "form_hide"
              }, null, 8, ["value"]),
              _createVNode(_component_a_form_item_rest, null, {
                default: _withCtx(() => [
                  _createVNode(_component_EditorComponent, {
                    ref: "editorComponentRef",
                    "is-extra": false,
                    content: _ctx.formState.content
                  }, null, 8, ["content"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 512),
          _createVNode(_component_a_form_item, {
            "wrapper-col": { span: 14, offset: 4 },
            style: {"margin-top":"16px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: _ctx.onSubmit,
                loading: _ctx.loading
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }, 8, ["onClick", "loading"]),
              _createVNode(_component_a_button, {
                style: {"margin-left":"10px"},
                onClick: _ctx.goBack,
                loading: _ctx.loading
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }, 8, ["onClick", "loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules", "label-col", "wrapper-col"])
    ]),
    _: 1
  }))
}